export const lineHeight = {
  '110%': '110%',
  '120%': '120%',
  '135%': '135%',
  '140%': '140%',
}
